












































































import Vue from 'vue';
import { PersonalizedCourse } from '@/store/types';
import LearningTools from '@/tools/learning';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  name: 'CoursesPersonalized',
  data() {
    return {
      loading: true,
      deleteDialog: false,
      deleteCourse: null as PersonalizedCourse | null,
    };
  },
  async mounted(): Promise<void> {
    this.$store.commit('setMainLoading', false);
    if (!this.$route.query.noInit) {
      this.loading = true;
      await LearningTools.loadCoursesPersonalized(this.$store);
    }
    this.loading = false;
  },
  methods: {
    onCourse(course: PersonalizedCourse): void {
      this.$store.commit('setPersonalizedCourse', course);
      this.$router.push(RoutePaths.LEVELS_PERSONALIZED);
    },
    onCreate(): void {
      this.$router.push(RoutePaths.COURSES_PERSONALIZED_WIZARD);
    },
    onDelete(course: PersonalizedCourse): void {
      this.deleteCourse = course;
      this.deleteDialog = true;
    },
    async onDeleteBack(): Promise<void> {
      this.deleteDialog = false;
      this.deleteCourse = null;
    },
    async onDeleteConfirm(): Promise<void> {
      if (this.deleteCourse) {
        this.loading = true;
        this.deleteDialog = false;
        await LearningTools.deletePersonalizedCourse(this.$store, this.deleteCourse.id);
        this.deleteCourse = null;
        await LearningTools.loadCoursesPersonalized(this.$store);
        this.loading = false;
      }
    },
  },
});

